// extracted by mini-css-extract-plugin
export var button = "_j6-2";
export var card = "_j6-0";
export var closeButtonContainer = "_j6-3";
export var iconContainer = "_j6-1";